import configService from 'app/services/config'

export default {
  methods: {
    getConfig (key, obj) {
      return configService.get(key, (obj ?? null))
    }
  }
}
